import BooleanFilter from './BooleanFilter';
import RemoteFilter from './RemoteFilter';
import EnumFilter from './EnumFilter';

const BaseFilters = {
  BooleanFilter,
  RemoteFilter,
  EnumFilter,
};

export default BaseFilters;
